import React from 'react';
import { CheckCircle, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import { PROGRAMS, MYREC_URL } from './constants';

const SuccessScreen = ({ formData, success, onClose }) => {
  const program = PROGRAMS.find((p) => p.value === formData.program);

  return (
    <div className="registration-success">
      <div className="success-icon">
        <CheckCircle size={60} />
      </div>
      <h2>Interest Submitted!</h2>
      <p>Thanks for your interest in the Randallstown Panthers. A coordinator will be in touch shortly.</p>

      <div className="success-details">
        <p><strong>Player:</strong> {formData.player_first_name} {formData.player_last_name}</p>
        <p><strong>Program:</strong> {program?.label}</p>
        <p><strong>Reference ID:</strong> {success.registration_id?.slice(0, 8).toUpperCase()}</p>
      </div>

      <div className="next-step-box">
        <h3>Next Step: Register on My Rec</h3>
        <p>
          This form only expresses interest. To officially register your child &mdash;
          including waivers and payment &mdash; please complete registration on the
          Liberty Road Recreation My Rec portal.
        </p>
        <a
          href={MYREC_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="pay-now-btn"
          data-testid="success-myrec-link"
        >
          Register on My Rec
          <ChevronRight size={20} />
        </a>
      </div>

      <p className="confirmation-note">
        A confirmation email has been sent to {formData.email}
      </p>

      {onClose && <Button onClick={onClose} className="close-btn">Close</Button>}
    </div>
  );
};

export default SuccessScreen;
